<div role="group" class="example-tel-input-container" [class.active]="focused" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
    <input class="day mat-mdc-form-field-input-control" maxlength="2"
        [class.mdc-text-field__input]="_disabled" [disabled]="_readOnly"
        #one [(ngModel)]="_value.day" placeholder="DD" (input)="changeDays($event.target)">
    <span [class.disabled]="_disabled">/</span>
    <input class="month mat-mdc-form-field-input-control" maxlength="2"
        [class.mdc-text-field__input]="_disabled" [disabled]="_readOnly"
        #two [(ngModel)]="_value.month" placeholder="MM" (input)="changeMonths($event.target)">
    <span [class.disabled]="_disabled">/</span>
    <input class="year mat-mdc-form-field-input-control" maxlength="4"
        [class.mdc-text-field__input]="_disabled" [disabled]="_readOnly"
        #three [(ngModel)]="_value.year" placeholder="YYYY" (input)="changeYears($event.target)">
</div>
@if (_showValidationError) {
    <div class="error-message">{{ _labelData.validationErrorText }}</div>
}
